module.exports = __webpack_public_path__ + "img/heqing.907827f2.png";